/*
window.onload = function () {
	const spinner = document.getElementById('loading');
	spinner.classList.add('loaded');
}
*/
// setTimeout(loaderClose,1000);

$(function () {
	var h = $(window).height();
	$('#is-loading ,#loading').height(h).css('display', 'block');
});

$(window).on("load", function () {
	$('#is-loading').delay(900).fadeOut(800);
	$('#loading').delay(600).fadeOut(300);

	//ロードしてからスライド
	$('.js-load').delay(1000).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more_01').delay(1400).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	$('.js-load-more_02').delay(1400).queue(function () {
		$(this).addClass('is-active').dequeue();
	});

	function load_effect() {
		var element = document.getElementsByClassName('load-fade');
		if (!element) return; // 要素がない場合は終了

		for (var i = 0; i < element.length; i++) {
			element[i].classList.add('is-show');
		}
	}
	setTimeout(load_effect, 900); // 600ミリ秒経過後に実行

});


$(function () {
	setTimeout('stopload()', 10000);
});

function stopload() {
	$('#is-loading').delay(900).fadeOut(800);
	$('#loading').delay(600).fadeOut(300);
}
